export const CONNECTOR_FREQUENCY_DAILY = 1;
export const CONNECTOR_FREQUENCY_WEEKLY = 2;
export const CONNECTOR_FREQUENCY_HALF_MONTHLY = 3;
export const CONNECTOR_FREQUENCY_MONTHLY = 4;
export const CONNECTOR_FREQUENCY_NEVER = 0;

//
export const DEFAULT_CHOISE = 0;
export const CSV_CHOISE = 1;
export const CONNECTOR_CHOISE = 2;

export const TRAVELGATE_ID = 2;
export const PUBLIC_CONNECTOR = 0;
export const DIRECT_CONNECTOR = 1;
export const HUB_CONNECTOR = 2;

export const FILE_FORMAT = 1;
export const DATABASE = 2;
export const WEBHOOK = 3;

export const TRAVEL_GATE_ID = 2;
export const TRAVEL_GATE_JSON = "travelgate json";
export const TRAVEL_GATE_FORM = "travelgate form";

export const UPDATE_EXISTING_CATALOG = "update";
export const ADD_TO_CATALOG = "add";

export const UPDATE_EXISTING_INVENTORY = "update";
export const ADD_TO_INVENTORY = "add";

export const DAILY = "daily";
export const WEEKLY = "weekly";
export const MONTHLY = "monthly";

export const STATUS_SUCCESS_INVENTORY = 2;

export const STATUS_PROCESSING = 1;
export const STATUS_PENDING = 0;
export const STATUS_SUCCESS_CATALOG = 2;
export const STATUS_FAILED = 3;
export const STATUS_IN_QUEUE = 4;
export const STATUS_STOPPED = 5;
export const STATUS_FINISH_PROCESSING = 2;

export const AFFILIATE = "affiliate";
export const PARTNERS = "partners";
export const MAPPINGS = "mappings";
export const HOME = "home";

export const ROLE_ADMIN = "admin";
export const ROLE_OWNER = "owner";
export const ROLE_OPERATOR = "operator";
export const ROLE_VIEWER = "viewer";

//PERMISSIONS
export const MANAGE_USERS = "manage_users";
export const MANAGE_CONNECTORS = "manage_connectors";
export const MANAGE_DESTINATIONS = "manage_destinations";
export const MANAGE_PAYMENTS = "manage_payments";
export const MANAGE_API_KEYS = "manage_api_keys";
export const MAP = "map";
export const DOWNLOAD = "download";
export const EXPORT = "export";
export const CREATE_INVENTORY = "create_inventory";
export const CREATE_CATALOG = "create_catalog";
export const MANAGE_INVENTORY_SEGMENTS = "manage_inventory_segments";
export const MANAGE_DUPLICATES = "manage_duplicates";
export const MANAGE_AFFILIATES = "manage_affiliates";
export const ADD_PARTNER = "add_partner";
export const REPORT_MAPPING_ERROR = "report_mapping_error";
export const MANAGE_PARTNER_ATTRIBUTES = "manage_partner_attributes";
export const MANAGE_COMPANY = "manage_company";
export const MANAGE_TEAM = "manage_team";
export const MANAGE_MODELS = "manage_models";
export const ACTIVATE_CATALOG = "activate_catalog";
export const MAP_MANUALLY = "map_manually";
export const LIST_OPPORTUNITIES = "list_opporunities";

export const MANAGE_HOTELS_RANKING = "manage_hotels_ranking";
export const DELETE_MAPPING = "delete_mapping";

export const GIATA_PROVIDER_ERROR = 0;
export const GIATA_PROVIDER_IN_QUEUE = 1;
export const GIATA_PROVIDER_PROCESSING = 2;
export const GIATA_PROVIDER_DONE = 3;

export const GIATA_MODEL = "giata";
export const CUPID_MODEL = "cupid";

export const TABLE_VIEW = "table_view";
export const CARD_VIEW = "card_view";

export const OVERVIEW = "overview";

export const SHOW_ALL = "all";
export const SHOW_ACTIVE = "active";
export const SHOW_INACTIVE = "inactive";

export const PROCCESSING_VIEW = "Proccessing";
export const PROCCESSED_VIEW = "Proccessed";

export const ROLES = {
    owner: [
        MANAGE_USERS,
        MANAGE_CONNECTORS,
        MANAGE_DESTINATIONS,
        MANAGE_PAYMENTS,
        MANAGE_API_KEYS,
        MAP,
        DOWNLOAD,
        EXPORT,
        CREATE_INVENTORY,
        CREATE_CATALOG,
        MANAGE_INVENTORY_SEGMENTS,
        MANAGE_DUPLICATES,
        MANAGE_AFFILIATES,
        ADD_PARTNER,
        REPORT_MAPPING_ERROR,
        MANAGE_PARTNER_ATTRIBUTES,
        MANAGE_COMPANY,
        MANAGE_TEAM,
        MANAGE_MODELS,
        ACTIVATE_CATALOG,
        MAP_MANUALLY,
        MANAGE_HOTELS_RANKING,
        DELETE_MAPPING,
        LIST_OPPORTUNITIES
    ],
    admin: [
        MANAGE_USERS,
        MANAGE_CONNECTORS,
        MANAGE_DESTINATIONS,
        MANAGE_PAYMENTS,
        MANAGE_API_KEYS,
        MAP,
        DOWNLOAD,
        EXPORT,
        CREATE_INVENTORY,
        CREATE_CATALOG,
        MANAGE_INVENTORY_SEGMENTS,
        MANAGE_DUPLICATES,
        MANAGE_AFFILIATES,
        ADD_PARTNER,
        REPORT_MAPPING_ERROR,
        MANAGE_PARTNER_ATTRIBUTES,
        MANAGE_COMPANY,
        MANAGE_TEAM,
        MANAGE_MODELS,
        ACTIVATE_CATALOG,
        MAP_MANUALLY,
        MANAGE_HOTELS_RANKING,
        DELETE_MAPPING,
        LIST_OPPORTUNITIES
    ],
    operator: [
        MAP,
        DOWNLOAD,
        EXPORT,
        CREATE_INVENTORY,
        CREATE_CATALOG,
        MANAGE_INVENTORY_SEGMENTS,
        MANAGE_DUPLICATES,
        ADD_PARTNER,
        LIST_OPPORTUNITIES
    ],
    viewer: [DOWNLOAD,LIST_OPPORTUNITIES],
};

export const STYLE_INPUT = {
    padding: "0.8125rem 1.25rem",
    appearance: "none",
    backgroundClip: "padding-box",
    backgroundColor: "#fff",
    border: "1px solid #f1f4f8",
    borderRadius: "0.375rem 0 0 0.375rem",
    boxShadow: "0 0",
    color: "#161c2d",
    lineHeight: "1.6",
    height: "55px",
    display: "block",
    fontSize: "1.0625rem",
    fontWeight: "400",
};

export const VERSIONS = [
    {
        new: [
            {
                name: "New Cupid model version v3.2. for improved mapping coverage.",
                subNew: [],
            },
            {
                name: "New mapping process:",
                subNew: [
                    "Continue to upload your inventory as you have done in the past.",
                    'Go to "Your Partners-->Overview" and select "Add New Partner Inventory."',
                    'Move to the "Mappings" section and press the "Play" icon.',
                ],
            },
        ],
        latest: true,
        version: "Cupid v2.0.3",
        released: "August 8th, 2023",
    },
    {
        new: [{ name: "New model algorithm version: 3.1" }],
        latest: false,
        version: "Cupid v2.0.2",
        released: "May 4th, 2023",
    },
    {
        new: [
            {
                name: "Manual mapping: We added the ability to map hotels manually in case they were missed in the mapping. You can also use the manually mapped hotels in subsequent mappings.",
            },
            {
                name: "Hotels ranking: Now you can upload rankings for your hotels, and see how your best selling hotels are performing in terms of mapping.",
            },
        ],
        improvement: [
            "We improved how we process and map hotels, which will result in a significant increase in mapping speed.",
        ],
        bugFix: [
            "We fixed some bugs in the “viewer” role.",
            "We fixed some bugs related to uploading CSV files.",
            "We fixed some bugs in the affiliate dashboard.",
        ],
        latest: false,
        version: "Cupid v2.0.2",
        released: "March 21, 2023",
    },
    {
        new: [
            {
                name: "Inventory Connector : Upload inventory using hub connectors",
            },
            {
                name: "Hotels ranking: Now you can upload rankings for your hotels, and see how your best selling hotels are performing in terms of mapping.",
            },
        ],
        improvement: [
            "Activate/Deactivate partner catalogs  : Choose the partner catalog that is considered active for reporting and analytics purposes<",
        ],
        bugFix: [
            "Fixed count of rows on CSV upload with empty rows,Handling of special characters (õ,ù,ñ, ...)",
        ],
        latest: false,
        version: "Cupid v2.0",
        released: "Jan 6th, 2023",
    },
];

export const IMPROVEMENTS = new Map([
    [
        "Mismatch between the country and the provided coordinates",
        "Mismatch country-coordinates",
    ],
    ["A number exists in the hotel name", "Number in hotel name"],
    ["No number exists in the hotel address", "No number in hotel address"],
    ["Could not extract street from address", "No street in address"],
    [
        "Mismatch between the extracted chain and the provided chain",
        "Mismatch in Chain",
    ],
    [
        "Mismatch between the extracted type and the provided type",
        "Mismatch in Property type",
    ],
]);

export const UNMAPPED_REASON = new Map([
    [
        "Numbers mismatching",
        "Partner hotel and candidate hotel have different numbers in their names",
    ],
    ["More than one candidate", "More than one candidate"],
    ["No candidates found", "No candidates found"],
    ["Duplicated in partner catalog", "Duplicated in partner catalog"],
    ["Not enough confidence", "Not enough confidence"],
]);

export const FACILITIES = new Map([
    /**Wifi */ [
        107,
        `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M15.9997 26H16.013M30.4082 11.601C26.6124 8.12265 21.5538 6 15.9995 6C10.4452 6 5.38665 8.12265 1.59082 11.601M6.30892 16.324C8.89308 14.0475 12.2851 12.6667 15.9996 12.6667C19.7142 12.6667 23.1062 14.0475 25.6904 16.324M20.9308 21.0335C19.572 19.9684 17.8599 19.3333 15.9995 19.3333C14.111 19.3333 12.3753 19.9877 11.0068 21.0821" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    ],
    /*parking*/ [
        46,
        `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M6.66699 17.3335H10.667M2.66699 12.0002L5.33366 13.3335L7.02785 8.25092C7.37755 7.20183 7.5524 6.67728 7.87671 6.28947C8.1631 5.94701 8.53088 5.68193 8.94633 5.51853C9.4168 5.3335 9.96972 5.3335 11.0756 5.3335H20.9251C22.0309 5.3335 22.5838 5.3335 23.0543 5.51853C23.4698 5.68193 23.8376 5.94701 24.1239 6.28947C24.4483 6.67728 24.6231 7.20183 24.9728 8.25092L26.667 13.3335L29.3337 12.0002M21.3337 17.3335H25.3337M9.06699 13.3335H22.9337C25.1739 13.3335 26.294 13.3335 27.1496 13.7695C27.9023 14.153 28.5142 14.7649 28.8977 15.5175C29.3337 16.3732 29.3337 17.4933 29.3337 19.7335V23.3335C29.3337 23.953 29.3337 24.2628 29.2824 24.5204C29.072 25.5782 28.2451 26.4052 27.1872 26.6156C26.9296 26.6668 26.6199 26.6668 26.0003 26.6668H25.3337C23.8609 26.6668 22.667 25.4729 22.667 24.0002C22.667 23.632 22.3685 23.3335 22.0003 23.3335H10.0003C9.63214 23.3335 9.33366 23.632 9.33366 24.0002C9.33366 25.4729 8.13975 26.6668 6.66699 26.6668H6.00033C5.38079 26.6668 5.07102 26.6668 4.81342 26.6156C3.75558 26.4052 2.92865 25.5782 2.71823 24.5204C2.66699 24.2628 2.66699 23.953 2.66699 23.3335V19.7335C2.66699 17.4933 2.66699 16.3732 3.10297 15.5175C3.48646 14.7649 4.09838 14.153 4.85103 13.7695C5.70668 13.3335 6.82678 13.3335 9.06699 13.3335Z" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    ],
    /*Currency exchange*/ [
        53,
        `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M21.3333 10.6664V6.00064C21.3333 4.89166 21.3333 4.33717 21.0997 3.9964C20.8956 3.69868 20.5795 3.49643 20.2237 3.43588C19.8164 3.36657 19.3129 3.59893 18.306 4.06366L6.47869 9.52243C5.58067 9.93689 5.13167 10.1441 4.80281 10.4655C4.51208 10.7497 4.29016 11.0965 4.15401 11.4795C4 11.9128 4 12.4073 4 13.3964V19.9998M22 19.3331H22.0133M4 14.9331L4 23.7331C4 25.2266 4 25.9733 4.29065 26.5437C4.54631 27.0455 4.95426 27.4535 5.45603 27.7091C6.02646 27.9998 6.77319 27.9998 8.26667 27.9998H23.7333C25.2268 27.9998 25.9735 27.9998 26.544 27.7091C27.0457 27.4535 27.4537 27.0455 27.7094 26.5437C28 25.9733 28 25.2266 28 23.7331V14.9331C28 13.4396 28 12.6929 27.7094 12.1225C27.4537 11.6207 27.0457 11.2128 26.544 10.9571C25.9735 10.6664 25.2268 10.6664 23.7333 10.6664L8.26667 10.6664C6.77319 10.6664 6.02646 10.6664 5.45603 10.9571C4.95426 11.2127 4.54631 11.6207 4.29065 12.1225C4 12.6929 4 13.4396 4 14.9331ZM22.6667 19.3331C22.6667 19.7013 22.3682 19.9998 22 19.9998C21.6318 19.9998 21.3333 19.7013 21.3333 19.3331C21.3333 18.9649 21.6318 18.6664 22 18.6664C22.3682 18.6664 22.6667 18.9649 22.6667 19.3331Z" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    ],
    /*Air conditioning*/ [
        109,
        `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M22.3522 8.66667C23.0846 7.84833 24.149 7.33333 25.3337 7.33333C27.5428 7.33333 29.3337 9.12419 29.3337 11.3333C29.3337 13.5425 27.5428 15.3333 25.3337 15.3333H17.3337M9.01885 5.33333C9.75128 4.515 10.8157 4 12.0003 4C14.2095 4 16.0003 5.79086 16.0003 8C16.0003 10.2091 14.2095 12 12.0003 12H2.66699M14.3522 26.6667C15.0846 27.485 16.149 28 17.3337 28C19.5428 28 21.3337 26.2091 21.3337 24C21.3337 21.7909 19.5428 20 17.3337 20H2.66699" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    ],
    /*"Childrens playground"*/ [
        56,
        `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M7.99986 14.6665H13.3332M10.6665 11.9998V17.3332M19.9999 15.9998H20.0132M23.9999 13.3332H24.0132M13.9318 6.6665H18.0679C21.5678 6.6665 23.3177 6.6665 24.6912 7.32975C25.9006 7.9137 26.9054 8.84929 27.574 10.014C28.3334 11.3368 28.4581 13.0822 28.7075 16.5732L29.0355 21.1658C29.1964 23.4177 27.4129 25.3332 25.1552 25.3332C24.0007 25.3332 22.9058 24.8204 22.1667 23.9334L21.6665 23.3332C21.209 22.7841 20.9802 22.5096 20.7197 22.2878C20.1736 21.8227 19.5125 21.5131 18.8057 21.3913C18.4685 21.3332 18.1111 21.3332 17.3964 21.3332H14.6033C13.8886 21.3332 13.5312 21.3332 13.194 21.3913C12.4872 21.5131 11.8261 21.8227 11.28 22.2878C11.0195 22.5096 10.7907 22.7841 10.3332 23.3332L9.83297 23.9334C9.09387 24.8204 7.99899 25.3332 6.84447 25.3332C4.58684 25.3332 2.80334 23.4177 2.96419 21.1658L3.29223 16.5732C3.54159 13.0822 3.66626 11.3368 4.42568 10.014C5.09432 8.84929 6.09911 7.9137 7.30847 7.32975C8.68202 6.6665 10.4319 6.6665 13.9318 6.6665Z" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    ],
    /*Restaurant*/ [
        3,
        `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M4.75 2.6665C4.75 2.25229 4.41421 1.9165 4 1.9165C3.58579 1.9165 3.25 2.25229 3.25 2.6665H4.75ZM15.4167 2.6665C15.4167 2.25229 15.0809 1.9165 14.6667 1.9165C14.2525 1.9165 13.9167 2.25229 13.9167 2.6665H15.4167ZM10.0833 2.6665C10.0833 2.25229 9.74755 1.9165 9.33333 1.9165C8.91912 1.9165 8.58333 2.25229 8.58333 2.6665H10.0833ZM8.58333 29.3332C8.58333 29.7474 8.91912 30.0832 9.33333 30.0832C9.74755 30.0832 10.0833 29.7474 10.0833 29.3332H8.58333ZM28 2.6665H28.75C28.75 2.46759 28.671 2.27683 28.5303 2.13617C28.3897 1.99552 28.1989 1.9165 28 1.9165V2.6665ZM21.3333 9.33317H20.5833H21.3333ZM27.25 29.3332C27.25 29.7474 27.5858 30.0832 28 30.0832C28.4142 30.0832 28.75 29.7474 28.75 29.3332H27.25ZM3.25 2.6665V11.9998H4.75V2.6665H3.25ZM3.25 11.9998C3.25 13.8807 4.78579 15.4165 6.66667 15.4165V13.9165C5.61421 13.9165 4.75 13.0523 4.75 11.9998H3.25ZM6.66667 15.4165H12V13.9165H6.66667V15.4165ZM12 15.4165C12.9062 15.4165 13.7752 15.0565 14.4159 14.4158L13.3553 13.3551C12.9958 13.7146 12.5083 13.9165 12 13.9165V15.4165ZM14.4159 14.4158C15.0567 13.775 15.4167 12.906 15.4167 11.9998H13.9167C13.9167 12.5082 13.7147 12.9957 13.3553 13.3551L14.4159 14.4158ZM15.4167 11.9998V2.6665H13.9167V11.9998H15.4167ZM8.58333 2.6665V29.3332H10.0833V2.6665H8.58333ZM28.75 19.9998V2.6665H27.25V19.9998H28.75ZM28 1.9165C26.033 1.9165 24.1465 2.6979 22.7556 4.0888L23.8163 5.14946C24.9259 4.03987 26.4308 3.4165 28 3.4165V1.9165ZM22.7556 4.0888C21.3647 5.47969 20.5833 7.36615 20.5833 9.33317H22.0833C22.0833 7.76397 22.7067 6.25905 23.8163 5.14946L22.7556 4.0888ZM20.5833 9.33317V17.3332H22.0833V9.33317H20.5833ZM20.5833 17.3332C20.5833 19.2141 22.1191 20.7498 24 20.7498V19.2498C22.9475 19.2498 22.0833 18.3856 22.0833 17.3332H20.5833ZM24 20.7498H28V19.2498H24V20.7498ZM27.25 19.9998V29.3332H28.75V19.9998H27.25Z" fill="#6275E7"/>
      </svg>`,
    ],
    /*Airport shuttle*/ [
        17,
        `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M23.6596 3.75048C24.946 2.42184 27.0713 2.40465 28.379 3.71232C29.6508 4.98415 29.6745 7.03878 28.4323 8.33958L24.7274 12.2193C24.437 12.5234 24.2919 12.6754 24.2024 12.8535C24.1232 13.0111 24.076 13.1829 24.0637 13.3589C24.0498 13.5577 24.097 13.7626 24.1916 14.1723L26.4955 24.1557C26.5925 24.5763 26.641 24.7865 26.6254 24.9899C26.6115 25.17 26.5612 25.3453 26.4776 25.5053C26.383 25.6861 26.2304 25.8387 25.9253 26.1439L25.4309 26.6383C24.6227 27.4465 24.2186 27.8505 23.805 27.9237C23.4439 27.9876 23.0724 27.8999 22.7779 27.6812C22.4407 27.4308 22.26 26.8887 21.8985 25.8044L19.2189 17.7653L14.7584 22.2258C14.4922 22.492 14.3591 22.6251 14.27 22.7819C14.1911 22.9208 14.1378 23.0727 14.1127 23.2305C14.0843 23.4085 14.1051 23.5956 14.1466 23.9699L14.3916 26.1744C14.4332 26.5486 14.454 26.7357 14.4256 26.9138C14.4004 27.0715 14.3471 27.2234 14.2682 27.3623C14.1792 27.5191 14.046 27.6522 13.7798 27.9185L13.5165 28.1818C12.8857 28.8125 12.5703 29.1279 12.2199 29.2192C11.9125 29.2994 11.5866 29.2671 11.3009 29.1283C10.9751 28.97 10.7277 28.5989 10.2329 27.8567L8.14182 24.72C8.05342 24.5874 8.00922 24.5211 7.95791 24.461C7.91232 24.4076 7.86259 24.3578 7.80918 24.3123C7.74904 24.2609 7.68274 24.2167 7.55014 24.1283L4.4135 22.0372C3.6713 21.5424 3.3002 21.295 3.14191 20.9693C3.00307 20.6836 2.9708 20.3577 3.05091 20.0503C3.14224 19.6998 3.45762 19.3845 4.08836 18.7537L4.3517 18.4904C4.61795 18.2241 4.75108 18.091 4.90785 18.0019C5.04673 17.9231 5.19866 17.8698 5.35639 17.8446C5.53444 17.8162 5.72156 17.837 6.09579 17.8786L8.3003 18.1235C8.67453 18.1651 8.86165 18.1859 9.03969 18.1575C9.19743 18.1323 9.34936 18.079 9.48824 18.0002C9.64501 17.9111 9.77813 17.778 10.0444 17.5117L14.5048 13.0513L6.46578 10.3716C5.38147 10.0102 4.83932 9.82947 4.58893 9.49226C4.37028 9.19781 4.28258 8.82629 4.34646 8.46515C4.41961 8.05156 4.82371 7.64746 5.6319 6.83927L6.12626 6.34491C6.43145 6.03972 6.58405 5.88712 6.76484 5.7926C6.92485 5.70894 7.10019 5.65865 7.28022 5.64479C7.48363 5.62912 7.6939 5.67765 8.11445 5.7747L18.06 8.06982C18.4732 8.16519 18.6799 8.21287 18.8794 8.19869C19.072 8.18499 19.2593 8.12962 19.4285 8.0364C19.6036 7.93985 19.7511 7.78749 20.0461 7.48277L23.6596 3.75048Z" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    ],
    /*Luggage storage*/ [
        91,
        `<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M11.167 28V9.33333C11.167 8.09337 11.167 7.47339 11.3033 6.96472C11.6732 5.58436 12.7513 4.50617 14.1317 4.1363C14.6404 4 15.2604 4 16.5003 4C17.7403 4 18.3603 4 18.8689 4.1363C20.2493 4.50617 21.3275 5.58436 21.6974 6.96472C21.8337 7.47339 21.8337 8.09337 21.8337 9.33333V18M21.8337 23.3333V28M9.56699 28H23.4337C25.6739 28 26.794 28 27.6496 27.564C28.4023 27.1805 29.0142 26.5686 29.3977 25.816C29.8337 24.9603 29.8337 23.8402 29.8337 21.6V15.7333C29.8337 13.4931 29.8337 12.373 29.3977 11.5174C29.0142 10.7647 28.4023 10.1528 27.6496 9.76931C26.794 9.33333 25.6739 9.33333 23.4337 9.33333H9.56699C7.32678 9.33333 6.20668 9.33333 5.35103 9.76931C4.59838 10.1528 3.98646 10.7647 3.60297 11.5174C3.16699 12.373 3.16699 13.4931 3.16699 15.7333V21.6C3.16699 23.8402 3.16699 24.9603 3.60297 25.816C3.98646 26.5686 4.59838 27.1805 5.35103 27.564C6.20668 28 7.32678 28 9.56699 28ZM17.567 23.3333H24.1003C24.4737 23.3333 24.6604 23.3333 24.803 23.2607C24.9284 23.1968 25.0304 23.0948 25.0943 22.9693C25.167 22.8267 25.167 22.64 25.167 22.2667V19.0667C25.167 18.6933 25.167 18.5066 25.0943 18.364C25.0304 18.2386 24.9284 18.1366 24.803 18.0727C24.6604 18 24.4737 18 24.1003 18H17.567C17.1936 18 17.0069 18 16.8643 18.0727C16.7389 18.1366 16.6369 18.2386 16.573 18.364C16.5003 18.5066 16.5003 18.6933 16.5003 19.0667V22.2667C16.5003 22.64 16.5003 22.8267 16.573 22.9693C16.6369 23.0948 16.7389 23.1968 16.8643 23.2607C17.0069 23.3333 17.1936 23.3333 17.567 23.3333Z" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    ],
    /*Swimming Pool*/ [
        433,
        `<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M19.9996 17L16.0246 11.76L15.0246 10.465L13.0846 7.85498L11.4996 9.07498L7.8296 11.95C7.63277 12.161 7.52332 12.4389 7.52332 12.7275C7.52332 13.0161 7.63277 13.2939 7.8296 13.505C8.3996 14.1 9.0596 14.17 9.4146 13.895L12.5796 11.21L14.1846 13.185L9.7346 16.655M2.89453 20.5749C4.83953 20.5749 4.83953 22.5749 6.77953 22.5749C8.71953 22.5749 8.72453 20.5749 10.6645 20.5749C12.6045 20.5749 12.6095 22.5749 14.5495 22.5749C16.4895 22.5749 16.4945 20.5749 18.4395 20.5749C20.3845 20.5749 20.3845 22.5749 22.3245 22.5749C24.2645 22.5749 24.2695 20.5749 26.2145 20.5749C28.1595 20.5749 28.1595 22.5749 30.1045 22.5749M2.89453 16.5299C4.83953 16.5299 4.83953 18.5299 6.77953 18.5299C8.71953 18.5299 8.72453 16.5299 10.6645 16.5299C12.6045 16.5299 12.6095 18.5299 14.5495 18.5299C16.4895 18.5299 16.4945 16.5299 18.4395 16.5299C20.3845 16.5299 20.3845 18.5299 22.3245 18.5299C24.2645 18.5299 24.2695 16.5299 26.2145 16.5299C28.1595 16.5299 28.1595 18.5299 30.1045 18.5299M24.7396 10.9549C24.7396 12.6394 23.374 14.0049 21.6896 14.0049C20.0051 14.0049 18.6396 12.6394 18.6396 10.9549C18.6396 9.27046 20.0051 7.90493 21.6896 7.90493C23.374 7.90493 24.7396 9.27046 24.7396 10.9549Z" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    ],
    /*Fitness centre*/ [
        11,
        `<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M9.69732 8.13617C9.40443 7.84328 8.92956 7.84328 8.63666 8.13617C8.34377 8.42907 8.34377 8.90394 8.63666 9.19683L9.69732 8.13617ZM23.3033 23.8635C23.5962 24.1564 24.0711 24.1564 24.364 23.8635C24.6569 23.5706 24.6569 23.0957 24.364 22.8028L23.3033 23.8635ZM27.97 28.5302C28.2629 28.8231 28.7378 28.8231 29.0307 28.5302C29.3235 28.2373 29.3235 27.7624 29.0307 27.4695L27.97 28.5302ZM27.6973 26.1362C27.4044 25.8433 26.9296 25.8433 26.6367 26.1362C26.3438 26.4291 26.3438 26.9039 26.6367 27.1968L27.6973 26.1362ZM5.03066 3.46951C4.73776 3.17661 4.26289 3.17661 3.97 3.46951C3.6771 3.7624 3.6771 4.23727 3.97 4.53017L5.03066 3.46951ZM5.30333 5.8635C5.59622 6.15639 6.0711 6.15639 6.36399 5.8635C6.65688 5.57061 6.65688 5.09573 6.36399 4.80284L5.30333 5.8635ZM23.97 28.8028C23.6771 29.0957 23.6771 29.5706 23.97 29.8635C24.2629 30.1564 24.7378 30.1564 25.0307 29.8635L23.97 28.8028ZM30.364 24.5302C30.6569 24.2373 30.6569 23.7624 30.364 23.4695C30.0711 23.1766 29.5962 23.1766 29.3033 23.4695L30.364 24.5302ZM2.63666 7.46951C2.34377 7.7624 2.34377 8.23727 2.63666 8.53017C2.92956 8.82306 3.40443 8.82306 3.69732 8.53017L2.63666 7.46951ZM9.03066 3.19683C9.32355 2.90394 9.32355 2.42907 9.03066 2.13617C8.73776 1.84328 8.26289 1.84328 7.97 2.13617L9.03066 3.19683ZM3.97 12.8028C3.6771 13.0957 3.6771 13.5706 3.97 13.8635C4.26289 14.1564 4.73776 14.1564 5.03066 13.8635L3.97 12.8028ZM14.364 4.53017C14.6569 4.23727 14.6569 3.7624 14.364 3.46951C14.0711 3.17661 13.5962 3.17661 13.3033 3.46951L14.364 4.53017ZM18.6367 27.4695C18.3438 27.7624 18.3438 28.2373 18.6367 28.5302C18.9296 28.8231 19.4044 28.8231 19.6973 28.5302L18.6367 27.4695ZM29.0307 19.1968C29.3235 18.9039 29.3235 18.4291 29.0307 18.1362C28.7378 17.8433 28.2629 17.8433 27.97 18.1362L29.0307 19.1968ZM8.63666 9.19683L23.3033 23.8635L24.364 22.8028L9.69732 8.13617L8.63666 9.19683ZM29.0307 27.4695L27.6973 26.1362L26.6367 27.1968L27.97 28.5302L29.0307 27.4695ZM3.97 4.53017L5.30333 5.8635L6.36399 4.80284L5.03066 3.46951L3.97 4.53017ZM25.0307 29.8635L30.364 24.5302L29.3033 23.4695L23.97 28.8028L25.0307 29.8635ZM3.69732 8.53017L9.03066 3.19683L7.97 2.13617L2.63666 7.46951L3.69732 8.53017ZM5.03066 13.8635L14.364 4.53017L13.3033 3.46951L3.97 12.8028L5.03066 13.8635ZM19.6973 28.5302L29.0307 19.1968L27.97 18.1362L18.6367 27.4695L19.6973 28.5302Z" fill="#6275E7"/>
      </svg>`,
    ],
]);

export const AMENITIES = new Map([
    [
        /**Coffee */ 1,
        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.1667 6.6665H15C15.8841 6.6665 16.7319 7.01769 17.357 7.64281C17.9821 8.26794 18.3333 9.11578 18.3333 9.99984C18.3333 10.8839 17.9821 11.7317 17.357 12.3569C16.7319 12.982 15.8841 13.3332 15 13.3332H14.1667M14.1667 6.6665H2.5V14.1665C2.5 15.0506 2.85119 15.8984 3.47631 16.5235C4.10143 17.1486 4.94928 17.4998 5.83333 17.4998H10.8333C11.7174 17.4998 12.5652 17.1486 13.1904 16.5235C13.8155 15.8984 14.1667 15.0506 14.1667 14.1665V6.6665ZM5 1.6665V3.33317M8.33333 1.6665V3.33317M11.6667 1.6665V3.33317" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        `,
    ],
    [
        /**Shower */ 4,
        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.50033 5L5.41699 2.91667C5.20329 2.67558 4.90475 2.52631 4.58366 2.5C3.90283 2.5 3.33366 3.06917 3.33366 3.75V14.1667C3.33366 14.6087 3.50925 15.0326 3.82181 15.3452C4.13437 15.6577 4.5583 15.8333 5.00033 15.8333H15.0003C15.4424 15.8333 15.8663 15.6577 16.1788 15.3452C16.4914 15.0326 16.667 14.6087 16.667 14.1667V10M8.33366 4.16667L6.66699 5.83333M1.66699 10H18.3337M5.83366 15.8333V17.5M14.167 15.8333V17.5" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        `,
    ],
    [
        /**TV */ 8,
        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.83366 17.5H14.167M3.33366 2.5H16.667C17.5875 2.5 18.3337 3.24619 18.3337 4.16667V12.5C18.3337 13.4205 17.5875 14.1667 16.667 14.1667H3.33366C2.41318 14.1667 1.66699 13.4205 1.66699 12.5V4.16667C1.66699 3.24619 2.41318 2.5 3.33366 2.5Z" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>        
        `,
    ],
    [
        /**Refrigerator */ 22,
        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.16699 8.33317H15.8337M12.5003 5.83317V10.8332M4.16699 4.99984C4.16699 4.11578 4.51818 3.26794 5.1433 2.64281C5.76842 2.01769 6.61627 1.6665 7.50033 1.6665H12.5003C13.3844 1.6665 14.2322 2.01769 14.8573 2.64281C15.4825 3.26794 15.8337 4.11578 15.8337 4.99984V16.6665C15.8337 17.1085 15.6581 17.5325 15.3455 17.845C15.0329 18.1576 14.609 18.3332 14.167 18.3332H5.83366C5.39163 18.3332 4.96771 18.1576 4.65515 17.845C4.34259 17.5325 4.16699 17.1085 4.16699 16.6665V4.99984Z" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>      
        `,
    ],
    [
        /**Air conditioning */ 11,
        `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M14.7503 6.41661C14.9942 6.18174 15.2917 6.00987 15.617 5.91588C15.9424 5.82188 16.2857 5.8086 16.6173 5.87718C16.9489 5.94575 17.2588 6.09412 17.5201 6.30944C17.7814 6.52476 17.9864 6.80053 18.1171 7.11288C18.2479 7.42524 18.3005 7.76475 18.2705 8.10203C18.2405 8.43932 18.1287 8.7642 17.9448 9.04855C17.761 9.3329 17.5106 9.56815 17.2153 9.73392C16.92 9.8997 16.5888 9.99101 16.2503 9.99995H1.66699M8.00033 3.83333C8.19339 3.63642 8.4323 3.49049 8.69564 3.40863C8.95898 3.32676 9.23852 3.31152 9.5092 3.36427C9.77988 3.41702 10.0332 3.53611 10.2466 3.71086C10.4599 3.88562 10.6265 4.11058 10.7315 4.36558C10.8365 4.62058 10.8766 4.89765 10.8482 5.17195C10.8198 5.44625 10.7237 5.70921 10.5687 5.93726C10.4136 6.16532 10.2044 6.35133 9.95976 6.47863C9.71513 6.60593 9.44274 6.67054 9.16699 6.66666H1.66699M10.5003 16.1666C10.6934 16.3635 10.9323 16.5094 11.1956 16.5913C11.459 16.6732 11.7385 16.6884 12.0092 16.6356C12.2799 16.5829 12.5332 16.4638 12.7466 16.2891C12.9599 16.1143 13.1265 15.8893 13.2315 15.6343C13.3365 15.3793 13.3766 15.1023 13.3482 14.828C13.3198 14.5537 13.2237 14.2907 13.0687 14.0627C12.9136 13.8346 12.7044 13.6486 12.4598 13.5213C12.2151 13.394 11.9427 13.3294 11.667 13.3333H1.66699" stroke="#6275E7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>     
        `,
    ],
]);
